import { OnInit, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { CashierService } from '../addfund-popup/cashier.service';
import { MainService } from '../_services/main.service';
import { PhoneVerificationComponent } from 'src/app/phone-verification/phone-verification.component';
import { Store } from '@ngrx/store';
import { AuthUserData } from '../store/actions/appActions';
import { environment } from 'src/environments/environment';
import * as QRCode from 'qrcode';
var VerificationComponent = /** @class */ (function () {
    function VerificationComponent(_cashierService, _appService, formBuilder, spinner, datepipe, _flashMessagesService, deviceService, dialog, data, store) {
        this._cashierService = _cashierService;
        this._appService = _appService;
        this.formBuilder = formBuilder;
        this.spinner = spinner;
        this.datepipe = datepipe;
        this._flashMessagesService = _flashMessagesService;
        this.deviceService = deviceService;
        this.dialog = dialog;
        this.data = data;
        this.store = store;
        this.verificatioSubmitted = false;
        this.uploadDocSubmitted = false;
        this.showUploadIdSuccessBox = false;
        this.showUploadBtn = false;
        this.isMobile = false;
        this.dateList = [];
        this.monthList = [{ 'key': '1', 'value': 'Jan' }, { 'key': '2', 'value': 'Feb' }, { 'key': '3', 'value': 'Mar' }, { 'key': '4', 'value': 'April' }, { 'key': '5', 'value': 'May' }, { 'key': '6', 'value': 'Jun' }, { 'key': '7', 'value': 'Jul' }, { 'key': '8', 'value': 'Aug' }, { 'key': '9', 'value': 'Sep' }, { 'key': '10', 'value': 'Oct' }, { 'key': '11', 'value': 'Nov' }, { 'key': '12', 'value': 'Dec' }];
        this.yearList = [];
        this.countryList = [{ 'name': 'Canada', 'code': 'CA', 'id': '38' }, { 'name': 'United States', 'code': 'US', 'id': '224' }];
        this.stateList = [];
        this.hideAlert = false;
        this.uploadTab = false;
        this.selectedFile = null;
        this.parentPage = 'Join';
        this.isDisable = false;
        this.isSubmitting = false;
        this.isQrcode = false;
        this.assetURL = "" + environment.assetURL;
        this.deviceType = '';
        if (data && data.user)
            this.userData = data.user;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.user_id = this.currentUser.id;
        }
        this.isMobile = this.deviceService.isMobile();
        this.deviceType = this.deviceService.os;
    }
    Object.defineProperty(VerificationComponent.prototype, "v", {
        get: function () { return this.verificationFrom.controls; },
        enumerable: true,
        configurable: true
    });
    VerificationComponent.prototype.ngOnInit = function () {
        this.isQrcode = false;
        this.verificationFrom = this.formBuilder.group({
            user_id: [this.user_id],
            FirstName: ['', Validators.required],
            LastName: ['', Validators.required],
            dd: ['', Validators.required],
            mm: ['', Validators.required],
            yyyy: ['', Validators.required],
            EmailAddress: ['', [Validators.required, Validators.email]],
            phoneNumber: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(14)]],
            AddressLine1: ['', Validators.required],
            AddressLine2: [''],
            city: ['', Validators.required],
            PostalCode: ['', Validators.required],
            CountryCode: ['', Validators.required],
            StateCode: ['', Validators.required],
            ipAddress: [this.ipAddress]
        });
        this.uploadDocForm = this.formBuilder.group({
            user_id: [this.user_id],
            document: ['', Validators.required],
            image: ['', Validators.required],
            file_name: ['', Validators.required],
        });
        if (this.userData.id != null && this.user_id > 0) {
            if (this.isAwareVerification == undefined)
                this.isAwareVerification = this.userData['verification_method'] == 'aware' ? true : false;
            this.setFormData();
        }
        else {
            this.getUserData();
        }
        this.dateList = [];
        this.yearList = [];
        for (var index = 1; index <= 31; index++) {
            this.dateList.push({ 'key': index.toString(), 'value': index });
        }
        for (var index = Number(this.datepipe.transform(Date.now(), 'y')); index >= 1905; index--) {
            this.yearList.push({ 'key': index.toString(), 'value': index });
        }
    };
    VerificationComponent.prototype.showQrcodeOld = function () {
        var _this = this;
        this.isQrcode = true;
        this.spinner.show();
        this._cashierService.kycVerification().subscribe(function (data) {
            _this.spinner.hide();
            if (data && data.status == "success") {
                var canvas = _this.qrCanvas.nativeElement;
                var option = {
                    Default: 'H',
                    errorCorrectionLevel: 'H',
                    width: 200,
                };
                QRCode.toCanvas(canvas, environment.phpUrl + "/kyc_verification?otp=" + data.otp, option, function (error) {
                    if (error)
                        console.error(error);
                    console.log('QR code generated!');
                });
            }
        });
    };
    VerificationComponent.prototype.showQrcode = function () {
        var _this = this;
        this.isQrcode = true;
        this.spinner.show();
        setTimeout(function () {
            _this.spinner.hide();
            var canvas = _this.qrCanvas.nativeElement;
            var option = {
                Default: 'H',
                errorCorrectionLevel: 'H',
                width: 200,
            };
            var url = 'https://app2.drafters.info/uC18';
            QRCode.toCanvas(canvas, url, option, function (error) {
                if (error)
                    console.error(error);
                console.log('QR code generated!');
            });
        }, 500);
    };
    VerificationComponent.prototype.ngOnChanges = function (e) {
        // need to detect input changes for user, parentPage
        this.userData = e.user.currentValue;
        this.parentPage = e.page.currentValue;
        this.user_id = this.userData.id;
    };
    VerificationComponent.prototype.getUserData = function () {
        var _this = this;
        this.spinner.show();
        this._appService.userDetail().subscribe(function (data) {
            if (data['status'] === 'success') {
                _this.userData = data['entities'];
                if (_this.isAwareVerification == undefined)
                    _this.isAwareVerification = _this.userData['verification_method'] == 'aware' ? true : false;
                _this.setFormData();
            }
            _this.spinner.hide();
        });
    };
    VerificationComponent.prototype.setFormData = function () {
        if (this.userData) {
            var dob = this.userData.dob.split('-');
            var dd = Number((dob[2]) ? dob[2] : '');
            var mm = Number((dob[1]) ? dob[1] : '');
            var yy = Number((dob[0]) ? dob[0] : '');
            this.v['dd'].setValue(dd.toString());
            this.v['yyyy'].setValue(yy.toString());
            this.v['mm'].setValue(mm.toString());
            this.v['EmailAddress'].setValue(this.userData.email);
            this.v['AddressLine1'].setValue(this.userData.address);
            this.v['city'].setValue(this.userData.hometown);
            this.v['PostalCode'].setValue(this.userData.zip_code);
            this.v['phoneNumber'].setValue(this.userData.primary_number);
            var currentTime = Math.floor(new Date().getTime() / 1000);
            var diff = currentTime - this.userData.doc_upload_time;
            var min = (diff > 0) ? diff / 60 : 0;
            this.showUploadIdSuccessBox = (this.userData.doc_upload == 1) ? true : false;
        }
    };
    VerificationComponent.prototype.onVerificationSubmit = function (el) {
        var _this = this;
        this.verificatioSubmitted = true;
        // stop here if form is invalid
        if (this.verificationFrom.invalid) {
            return;
        }
        else {
            this.spinner.show();
            this.isDisable = true;
            this.sub_tsevoVerification = this._cashierService.tsevoVerification(this.verificationFrom.value).pipe(first()).subscribe(function (data) {
                _this.verificatioSubmitted = false;
                _this.isDisable = false;
                _this.spinner.hide();
                if (data != null) {
                    if (data.status == "success") {
                        _this.hideAlert = true;
                        _this._flashMessagesService.show(data.message, { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
                        el.scrollIntoView();
                    }
                    else {
                        _this.userData.verification_attempts++;
                    }
                    if (_this.v.phoneNumber.value && _this.userData.verify_phone != null && _this.userData.verify_phone == 'N' && environment.IS_PHONE_VERIFICATION) {
                        setTimeout(function () {
                            //Phone number not verified?
                            _this.phoneVerificationRef = _this.dialog.open(PhoneVerificationComponent, {
                                width: '500px',
                                data: { phoneNumber: _this.v.phoneNumber.value }
                            });
                            _this.phoneVerificationRef.afterClosed().subscribe(function (res) {
                                if (res.verify_phone) {
                                    _this.v['phoneNumber'].setValue(_this.formatPhone(res.primary_number));
                                    _this.userData.verify_phone = res.verify_phone;
                                    _this.userData.primary_number = res.primary_number;
                                }
                            });
                        }, 2000);
                    }
                }
                else {
                    _this.hideAlert = true;
                    _this._flashMessagesService.show('Something went wrong! Please try again', { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: true });
                    setTimeout(function () { _this.hideAlert = false; }, 10010);
                }
            }, function (error) {
                console.log(error);
            });
        }
    };
    VerificationComponent.prototype.onSelectFile = function (files) {
        var _this = this;
        var file1 = files[0];
        var file = file1;
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!file.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = function (e) { return _this.imageSrc = reader.result; };
        reader.readAsDataURL(file);
        this.uploadDocForm.get('file_name').setValue(file.name);
        this.uploadDocForm.get('image').setValue(files[0]);
        this.selectedFile = files[0];
        this.showUploadBtn = true;
    };
    VerificationComponent.prototype.changeVerificationstatus = function () {
        this.userData.payment_verified = "Y";
        this.store.dispatch(new AuthUserData(this.userData.payment_verified));
    };
    VerificationComponent.prototype.onDocSubmit = function () {
        var _this = this;
        this.uploadDocSubmitted = true;
        // stop here if form is invalid
        if (this.uploadDocForm.invalid) {
            return;
        }
        else {
            this.isSubmitting = true;
            this.spinner.show();
            var form = new FormData();
            form.append('document', this.selectedFile, this.selectedFile.name);
            form.append('login_user_id', this.currentUser.id);
            this.sub_submitDoc = this._cashierService.submitVerificationDocument(form).pipe(first()).subscribe(function (data) {
                _this.isSubmitting = false;
                _this.spinner.hide();
                if (data != null) {
                    if (data.status === 'success') {
                        _this.userData.doc_upload = 1;
                        _this.showUploadIdSuccessBox = true;
                        _this.userData.doc_upload_time = Math.floor(new Date().getTime() / 1000);
                        _this.resetFile();
                        _this._flashMessagesService.show(data.message, { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
                        _this.changeVerificationstatus();
                        if (_this.data.lobby) {
                            window.location.href = environment.SITE_URL + "/drafts/register/welcome";
                        }
                    }
                    else {
                        _this._flashMessagesService.show(data.message, { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: true });
                    }
                }
                else {
                    _this._flashMessagesService.show('Something went wrong! Please try again', { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: true });
                }
            }, function (error) {
                _this.isSubmitting = false;
                _this.spinner.hide();
                console.log(error);
            });
        }
    };
    VerificationComponent.prototype.getStateList = function (country_code) {
        var _this = this;
        var country = this.countryList.find(function (x) { return (x.code == country_code); });
        this.sub_stateList = this._cashierService.stateList(country.id).subscribe(function (res) {
            if (res.status === 'success') {
                _this.stateList = res.entities;
            }
        });
    };
    VerificationComponent.prototype.uploadDocAction = function (action) {
        if (action == 'change')
            this.uploadTab = true;
        else
            this.hideAlert = true;
    };
    VerificationComponent.prototype.resetFile = function () {
        this.imageSrc = null;
    };
    VerificationComponent.prototype.keyPress = function (event) {
        var pattern = /[0-9]/;
        var phonel = this.v.phoneNumber.value;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
            event.preventDefault();
        }
        else {
            var countNumber = (this.v.phoneNumber.value) ? phonel.length : 0;
            if (countNumber === 3 || countNumber === 7) {
                var phone_number = this.v.phoneNumber.value + '-';
                this.v['phoneNumber'].setValue(phone_number);
            }
        }
    };
    VerificationComponent.prototype.formatPhone = function (phone) {
        if (phone) {
            phone = phone.replace('+1 ', '');
            phone = phone.replace(/-/g, '');
            var b = '-';
            var position1 = 3;
            var position2 = 6;
            return [phone.slice(0, position1), b, phone.slice(position1, position2), b, phone.slice(position2)].join('');
        }
        else {
            return;
        }
    };
    return VerificationComponent;
}());
export { VerificationComponent };
